'use client'
import React, { useState } from 'react'
import { Popover } from 'antd'
import styles from './styled.module.scss'
import DownloadPop from '../DownloadPop'
import cls from 'classnames'

const Download = () => {
  const [isOpen, setIsOpen] = useState(false)
  const content = (
    <div>
      <DownloadPop visible={isOpen} />
    </div>
  )
  return (
    <div className={styles.container}>
      <Popover
        trigger={'click'}
        content={content}
        getPopupContainer={(node) => node.parentNode as HTMLElement}
        overlayClassName={cls(styles.popoverContent)}
        onOpenChange={(value) => {
          setIsOpen(value)
        }}
      >
        <div>
          <i className="iconfont iconxiazai-241 f20" style={{ fontSize: '20px !important' }}></i>
        </div>
      </Popover>
    </div>
  )
}

export default Download
